var map = {
	"./comission_details.svg": "472b",
	"./giftcard_details.svg": "8d2b",
	"./investment_details.svg": "52da",
	"./mkt_purchase_details.svg": "2cb5",
	"./mkt_sale_details.svg": "9890",
	"./payment_details.svg": "03cc",
	"./refund_details.svg": "fc62",
	"./topup_details.svg": "a528",
	"./voucher_details.svg": "232c",
	"./withdraw_details.svg": "89a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f1e";